import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=605a1034&scoped=true&"
import script from "./Insurance.vue?vue&type=script&lang=js&"
export * from "./Insurance.vue?vue&type=script&lang=js&"
import style0 from "./Insurance.vue?vue&type=style&index=0&id=605a1034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605a1034",
  null
  
)

export default component.exports